import { render, staticRenderFns } from "./PeerGroupPacketCreator.vue?vue&type=template&id=044fe510&scoped=true&"
import script from "./PeerGroupPacketCreator.vue?vue&type=script&lang=ts&"
export * from "./PeerGroupPacketCreator.vue?vue&type=script&lang=ts&"
import style0 from "./PeerGroupPacketCreator.vue?vue&type=style&index=0&id=044fe510&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044fe510",
  null
  
)

export default component.exports